"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeout = exports.DEFAULT_TIMEOUT_MS = exports.TIMEOUT_ERRORS = void 0;
const cross_fetch_1 = require("cross-fetch");
const node_abort_controller_1 = __importDefault(require("node-abort-controller"));
var TIMEOUT_ERRORS;
(function (TIMEOUT_ERRORS) {
    TIMEOUT_ERRORS[TIMEOUT_ERRORS["ETIMEDOUT"] = 504] = "ETIMEDOUT";
})(TIMEOUT_ERRORS = exports.TIMEOUT_ERRORS || (exports.TIMEOUT_ERRORS = {}));
/**
 * Navigator.connection is experimental and as of writing not supported in Safari and Firefox.
 * DEFAULT_TIMEOUT_MS detects whether `fetch` is being called from a client or server, and
 * if we can detect the effectiveType from a supported browser, that information is used to
 * set the timeout. Because this is still experiemental, the interface needs to be extended
 * to add the missing types.
 * https://caniuse.com/mdn-api_navigator_connection
 */
const customNavigator = typeof navigator === "undefined" ? null : navigator;
const connectionType = ((_a = ((customNavigator === null || customNavigator === void 0 ? void 0 : customNavigator.connection) ||
    (customNavigator === null || customNavigator === void 0 ? void 0 : customNavigator.mozConnection) ||
    (customNavigator === null || customNavigator === void 0 ? void 0 : customNavigator.webkitConnection))) === null || _a === void 0 ? void 0 : _a.effectiveType) || "";
const SERVER_DEFAULT_TIMEOUT_MS = 800;
const CLIENT_DEFAULT_TIMEOUT_MS = 3000;
const MOBILE_2G_DEFAULT_TIMEOUT_MS = 5000;
exports.DEFAULT_TIMEOUT_MS = typeof window === "undefined"
    ? SERVER_DEFAULT_TIMEOUT_MS
    : ["slow-2g", "2g"].includes(connectionType)
        ? MOBILE_2G_DEFAULT_TIMEOUT_MS
        : CLIENT_DEFAULT_TIMEOUT_MS;
const timeout = (ctx, next) => {
    if (!ctx.options.timeout) {
        ctx.options.timeout = exports.DEFAULT_TIMEOUT_MS;
    }
    if (!ctx.options.abortController) {
        ctx.options.abortController = new node_abort_controller_1.default();
    }
    ctx.options.signal = ctx.options.abortController.signal;
    return new Promise(resolve => {
        let resolved = false;
        const timeout = setTimeout(() => {
            var _a;
            (_a = ctx.options.abortController) === null || _a === void 0 ? void 0 : _a.abort();
            if (!ctx.response) {
                ctx.response = new cross_fetch_1.Response(`{ "message": "ETIMEDOUT ${exports.DEFAULT_TIMEOUT_MS}ms" }`, {
                    status: TIMEOUT_ERRORS.ETIMEDOUT,
                    statusText: "ETIMEDOUT",
                });
            }
            if (!resolved) {
                resolved = true;
                return resolve();
            }
        }, ctx.options.timeout);
        return next()
            .catch(err => {
            if (err.name !== "AbortError")
                throw err;
        })
            .finally(() => clearTimeout(timeout))
            .then(res => {
            // if timeout happens it resolves the parent promise but this sub promise may keep running (missing AbortController)
            // so we need to make check for it to avoid resolving already resolved promise (system error)
            if (!resolved) {
                resolved = true;
                return resolve(res);
            }
        });
    });
};
exports.timeout = timeout;
//# sourceMappingURL=timeout.js.map